import { Observable, Observer } from "rxjs";
import { ILoginResonse, IOrganisation, AccountStatus, IUser, ICourse } from "../model/ModelTypes";
import { IHttpClient } from "./IHttpClient";
import { isNullOrUndefined } from "util";

export interface RegisterRequest {
    name?: string;
    username?: string;
    email_address?: string;
    password?: string;
    confirmPassword?: string;
    organisation_code: string;
    organisation_id?: string;
    role?: string;
    group?: string;
    accessCode?: string;
    autoApprove?: boolean;
    is_admin?: boolean;
}
export interface ResetPasswordRequest {
    organisation_code: string;
    username: string;
    email: string;
}
export interface ExecuteResetPasswordRequest {
    code: string;
    password: string;
    password1: string;
}

export interface IRegistrationResponse {
    response: string;
    user: IUser;
}

export interface IApi {
    authenticateUser(): Observable<ILoginResonse>;
    login(username: string, password: string,
          organisationName: string,
          organisationCode: string): Observable<ILoginResonse>;
    getAllOrganisation(): Observable<IOrganisation[]>;
    getOrganisationDetails(organisationCode: string): Observable<IOrganisation>;
    registerAccount(request: RegisterRequest): Observable<IRegistrationResponse>;
    resetPassword(request: ResetPasswordRequest): Observable<string>;
    executeResetPassword(request: ExecuteResetPasswordRequest): Observable<string>;
    executeVerifyAccount(organisationCode: string, code: string): Observable<AccountStatus>;
    editUser(request: EditUserRequest): Observable<IUser>;
    getCoursesDetails(organisationCode: string, username: string, courses?: string[]): Observable<ICourse[]>;

}

export class Api implements IApi {
    protected httpClient: IHttpClient;
    protected authenticatedHttpClient: IHttpClient;
    constructor(httpClient: IHttpClient, authenticatedHttpClient?: IHttpClient) {
        this.httpClient = httpClient;
        if (!isNullOrUndefined(authenticatedHttpClient)) {
            this.authenticatedHttpClient = authenticatedHttpClient;
        }
    }
    executeResetPassword(request: ExecuteResetPasswordRequest): Observable<string> {
        return Observable.create((observer: Observer<string>) => {
            this.httpClient
            .getInstance()
            .put(`api/organisations/users/reset`, request)
            .then( response => {
                if ( response.status === 200 ) {
                    observer.next(response.data.response);
                } else {
                    observer.error(new Error("Something went wrong"));
                }
                return observer.complete();
            }).catch( error => {
                observer.error(error);
                return observer.complete();
            });
        });
    }
    resetPassword(request: ResetPasswordRequest): Observable<string> {
        return Observable.create((observer: Observer<string>) => {
            this.httpClient
                .getInstance()
                .post(`api/organisations/${request.organisation_code}/users/reset`, request)
                .then( response => {
                    if ( response.status === 200 ) {
                        observer.next(response.data.response);
                    } else {
                        observer.error("Something went wrong");
                    }
                    return observer.complete();

                }).catch( error => {
                    observer.error(error);
                    return observer.complete();

                });
        });
    }
    registerAccount(request: RegisterRequest): Observable<IRegistrationResponse> {
        return Observable.create((observer: Observer<string>) => {
            this.httpClient
                .getInstance()
                .post(`api/organisations/${request.organisation_code.toLowerCase()}/users/register`, request)
                .then( response => {
                    if ( response.status === 200 ) {
                        observer.next(response.data);
                    } else {
                        observer.error("Something went wrong");
                    }
                    return observer.complete();

                }).catch( error => {
                    observer.error(error);
                    return observer.complete();
                });
        });
    
    }
    getOrganisationDetails(organisationCode: string): Observable<IOrganisation> {
        return Observable.create((observer: Observer<IOrganisation>) => {
            if (!isNullOrUndefined(this.httpClient)) {
                let axiosInstance = (!isNullOrUndefined(this.authenticatedHttpClient)) ? 
                this.authenticatedHttpClient.getInstance() :
                this.httpClient.getInstance();
                axiosInstance.get(`api/organisation?code=${organisationCode}`)
                .then( response => {
                    if (response.status === 200) {
                        observer.next(response.data);
                    } else {
                        observer.error(new Error("Something went wrong"));
                    }
                    return observer.complete();

                }).catch( error => {
                    observer.error(error);
                    return observer.complete();

                });
            } else {
                observer.error(new Error("Something went wrong"));
                return observer.complete();

            }
        });
       
    }
    authenticateUser(): Observable<ILoginResonse> {
        return Observable.create((observer: Observer<ILoginResonse>) => {
            if (!isNullOrUndefined(this.authenticatedHttpClient)) {
                this.authenticatedHttpClient.getInstance().post("api/users/authenticate")
                .then( (response) => {
                    if (isNullOrUndefined(response)) {
                        return observer.error( new Error("Failed to authenticate user"));
                    }
                    if (!isNullOrUndefined(response) && response.status === 200) {
                        observer.next(response.data);
                    } else {
                        observer.error("Something went wrong");
                    }
                    return observer.complete();

                }).catch( error => {
                    observer.error(error);
                    return observer.complete();

                });
            } else {
                observer.error( new Error("Failed to authenticate user"));
                return observer.complete();

            }
        });
    }

    login(username: string, password: string, 
          organisationName: string, 
          organisationCode: string): Observable<ILoginResonse> {
            let requestData = {
                user: {
                    username: username,
                    password: password,
                    organisation: {
                        name: organisationName,
                        code: organisationCode
                    }
                }
            };
            return Observable.create((observer: Observer<ILoginResonse>) => {
                this.httpClient.getInstance().post("api/login", requestData)
                    .then( (response) => {
                        if (!isNullOrUndefined(response) &&
                         response.status === 200 && isNullOrUndefined(response.data.error)) {
                            observer.next(response.data);
                        } else {
                            observer.error("Something went wrong");
                        }
                        return observer.complete();

                    }).catch( error => {
                        observer.error(error);
                        return observer.complete();

                    });
            }); 
    }

    getAllOrganisation(): Observable<IOrganisation[]> {
        return Observable.create((observer: Observer<IOrganisation[]>) => {
            this.httpClient.getInstance().get("/api/organisations")
                .then( response => {
                    
                    if (!isNullOrUndefined(response) && response.status === 200) {
                        observer.next(response.data);
                    } else {
                        observer.error(new Error("Something went wrong"));
                    }
                    return observer.complete();
                    
                }).catch( error => {
                    observer.error(error);
                    return observer.complete();

                });
        });
        
    }

    executeVerifyAccount(organisationCode: string, code: string): Observable<AccountStatus> {
        return Observable.create((observer: Observer<AccountStatus>) => {
            this.
            httpClient.
            getInstance().
            post(`api/organisations/${organisationCode}/users/verify`, {code: code})
            .then( result => {
                
                if (result.status === 200) {
                    if (!isNullOrUndefined(result.data)) {
                        switch (result.data.status) {
                            case AccountStatus.approved :
                                observer.next(AccountStatus.approved);
                                break;
                            case AccountStatus.PendingAdminApproval :
                                observer.next(AccountStatus.PendingAdminApproval);
                                break;
                            default:
                                observer.error(new Error("Something went wrong"));
                                break;
                        }
                    }
                    return observer.complete();
                }
            })
            .catch( error => {
                observer.error(error);
                return observer.complete();

            });
        });

    }

    editUser(request: EditUserRequest): Observable<IUser> {
        return Observable.create( ( observer: Observer<IUser> ) => {
            this.
            authenticatedHttpClient.
            getInstance().
            post(`api/users/${request.organisationCode}/${request.organisationUsername}/`, request).
            then( result => {
                if (result.status === 200) {
                    observer.next(result.data);
                } else {
                    observer.error(new Error("Something went wrong")); 
                }
                return observer.complete();
            })
            .catch( error => {
                observer.error(error);
                return observer.complete();
            });
        });
    }

    getCoursesDetails(organisationCode: string, username: string, courses?: string[]): Observable<ICourse[]> {
        return Observable.create( (observer: Observer<ICourse[]>) => {
            let queryString = undefined;
            if (!isNullOrUndefined(courses) && courses.length > 0) {
                queryString =  `?code=${encodeURI(courses.join(","))}`;
            }
            let path = `/api/users/${organisationCode}/${username}/courses`;
            if (!isNullOrUndefined(queryString)) {
                path += queryString;
            }
            this.authenticatedHttpClient.getInstance()
            .get(path)
            .then(
                response => {
                    if (response.status === 200) {
                        observer.next(response.data);
                    }
                    return observer.complete();
                } 
            ).catch(
                error => {
                    observer.error(error);
                    return observer.complete();
                }
            );
        });
    }
}

export type EditUserRequest = {
    email?: string;
    name?: string;
    password?: string;
    confirmPassword?: string;
    organisationCode: string;
    organisationUsername: string;
};



// WEBPACK FOOTER //
// ./src/utility/IApi.ts